// LEGACY UI: replace with Separator (or FieldSeparator for a labelled divider) from @workspace/frontend-ui.
// Don't import this in new code; legacy-ui.json tracks the remaining importers
// and only shrinks (scripts/legacy-ui-check.mjs).
import classNames from "@casino/external/classNames";

type Props = {
  className?: string;
};

const KeylineText: FC<Props> = ({ children, className }) => (
  <div
    className={classNames(
      "grid gap-2 grid-flow-col items-center grid-cols-[1fr_auto_1fr]",
      className,
    )}
  >
    <hr className="h-px border-0 bg-muted" />
    {children}
    <hr className="h-px border-0 bg-muted" />
  </div>
);

export default KeylineText;
